// removed by extract-text-webpack-plugin
module.exports = {"SubjectAreaRow":"adGw8IsTUuS2Y3466nSay","carousel":"_14Yj-S9afm3j44OJaXmnwK","NavPrev":"qOCiLyJrRW-uGTkiKzYEh","NavNext":"_22YXvdiC2z_nBgIFWh7JNW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Course/CourseSubject.css
// module id = 1187
// module chunks = 0